<template>
    <div class="page-wrapper page" :class="showRoute">
        <div class="space-helper"></div>
       
<!-- full width top blurb --> 
    
        <!-- <div v-if="showRoute == '404'" v-for="(value, key, index) in blurbs" :key="index" > -->
            <div v-if="showRoute == '404'" ></div>
            <!-- <div  class="page-grid-fix background-img top-blurb" v-if="key == 0"  v-bind:style="{  backgroundImage:  'linear-gradient(rgba(0, 0, 0, 0.527),rgba(0, 0, 0, 0.5)), ' + 'url(' +  value.blurb_image + ')'}">    -->
                <div class="page-grid-fix background-img top-blurb" :style="{ 'background-size': 'contain', 'background-position': 'center', 'background-repeat': 'no-repeat','backgroundImage': 'linear-gradient(rgba(0, 0, 0, 0.527), rgba(0, 0, 0, 0.5)), url(/images/404.jpg)' }">
  <!-- Your content here -->
            </div>
                <!-- <div class="overlay-mask"></div>  --> 
                <article class="grid-container columns-one transparent">
                    <section>
                            <h4 >This page is temporarily unavailable</h4>
                            <!-- <div>page not found</div> -->
                    </section>
                </article>
            </div>

</template>

<!-- <style scope lang="scss">

</style> -->


<script>
import ContactForm from '../components/ContactForm.vue';
import EnquiryForm from '../components/EnquiryForm.vue';

export default {
    name: 'Errors',
    components: {
        ContactForm,
        EnquiryForm,
    },
    data() {
        return {
           banner: '',
           page: [],
           blurbs: [],
           showRoute: {
               showRoute : this.$route.name
           },
        };
    },    
    watch: {
        '$route.name': function () {
          this.showRoute = this.$route.name;
        },    
    },
    created() {
        this.showRoute = this.$route.name
       
    },
    mounted() {
        this.getPage()
    },
    computed: {     

        bannerVideo() {
            var file = this.page[7];
            if ( file.includes('mp4') == 1) {
                return 'video'
            } 
        },
        bannerImage() {
            var file = this.page[7];
            if ( file.includes('jpg') == 1) {
                return 'image'
            } 
        },
    },
    methods: {
        getPage(address) {
            var pageSlug = this.showRoute
             this.$axios.get(address ? address : "/api/" + pageSlug).then(response => {
                this.page = response.data;
                this.blurbs = response.data[11];
            });
        },
    },
};
</script>
